<template>
    <div>
        <point
                class="row"
                v-bind:key="i"
                v-bind:number="i + 1"
                v-bind:point="point"
                v-for="(point, i) in options.points"/>
    </div>
</template>

<script>
    import PageComponentTemplate from '../page-component-template';
    import Point from './point'

    export default {
        name: 'page-component-points',
        extends: PageComponentTemplate,
        components: {
            Point
        }
    }
</script>

<style lang="less" scoped>
</style>